// extracted by mini-css-extract-plugin
export default {"title":"UserForm_title__kWa4w","form":"UserForm_form__jXAeN","middleName":"UserForm_middleName__zUK+y","orders":"UserForm_orders__xJS-5","footer":"UserForm_footer__ih1eU"};